module.exports = __webpack_public_path__ + "img/icon_btn.7a269e34.png";